module.exports = __webpack_public_path__ + "img/img2.631c7066.jpg";